import api from './api';

const API_PREFIX = '/tag';

const getTags = ({ search, customerEnvId }) =>
  api.get(`${API_PREFIX}/${customerEnvId}/tags`, {
    params: {
      ...(search ? { search } : {}),
    },
  });

const TagService = {
  getTags,
};

export default TagService;
